import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { HorizontalLogoTwoTone } from '../../branding/HorizontalLogoTwoTone';

const Header = styled.header`
   padding-top: 25px;
   text-align: center;

   svg {
      width: 200px;
   }

   @media (min-width: 415px) {
      & {
         padding-top: 50px;

         svg {
            width: 250px;
         }
      }
   }
`;

const LogoHeader = () => (
   <Header>
      <Link to="/">
         <HorizontalLogoTwoTone />
      </Link>
   </Header>
);

export { LogoHeader };
